import {createSlice} from '@reduxjs/toolkit';
import {fetchWrapper} from '../../helper/utils';
import {setError} from '../error/errorSlice';
import {setLoader} from '../loader/loaderSlice';
const {REACT_APP_API_URL} = process.env;


export const passwordSlice = createSlice({
    name: 'password',
    initialState: {
        password: '',
        isValid: false,
        showError: false,
        isSuccess: null,
    },
    reducers: {
        setPassword: (state, action) => {
            state.password = action.payload;
        },
        setIsValid: (state, action) => {
            state.isValid = action.payload;
        },
        setShowError: (state, action) => {
            state.showError = action.payload;
        },
        setIsSuccess: (state, action) => {
            state.isSuccess = action.payload
        }
    },
});

export const {setPassword, setIsValid, setShowError, setIsSuccess} = passwordSlice.actions;

export const sendAPIRequest = (password, token) => dispatch => {
    dispatch(setLoader(true));

    const params = {
        "password": password,
    };
    const customHeaders = {
        'Authorization': `Bearer ${token}`,
    };

    fetchWrapper(`${REACT_APP_API_URL}/users/me/updatePassword`, {
        body: params,
        headers: customHeaders,
    })
        .then((data) => {
            dispatch(setIsSuccess(true))
        })
        .catch((error) => {
            dispatch(
                setError({
                    show: true,
                    text: 'Failed to change password',
                    type: 'password'
                })
            );
            console.log(error);
            dispatch(setIsSuccess(false))
        })
        .then(() => dispatch(setLoader(false)))
};

export const selectPassword = state => state.password.password;
export const selectValidity = state => state.password.isValid;
export const selectShowError = state => state.password.showError;
export const selectSuccess = state => state.password.isSuccess;

export default passwordSlice.reducer;
